import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import Link from '../Link/Link.js';
import LinkLists from '../LinkLists/LinkLists.js';

const SpotlightedStores = (_param)=>{
    var { className , items , storesUrl  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "items",
        "storesUrl"
    ]);
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({
        className: classnames('spotlighted-stores', className)
    }, rest), /*#__PURE__*/ React.createElement("div", {
        className: "site-container"
    }, /*#__PURE__*/ React.createElement(LinkLists, {
        items: items
    }), /*#__PURE__*/ React.createElement(Link, {
        className: "spotlighted-stores__link",
        label: getLabel('common.component.spotlightedStores.link'),
        url: storesUrl,
        openInNewWindow: false
    })));
};

export { SpotlightedStores as default };
//# sourceMappingURL=SpotlightedStores.js.map
